import { Component, computed, input, signal } from '@angular/core';

@Component({
  selector: 'app-brand-card',
  imports: [],
  templateUrl: './brand-card.component.html',
  styleUrl: './brand-card.component.scss'
})
export class BrandCardComponent {
  readonly #failedImageUrl = signal<string | null>(null);

  readonly image = input.required<string | null | undefined>();
  readonly alt = input.required<string>();

  readonly displayImage = computed(() => {
    const imageUrl = this.image()?.trim();

    return imageUrl && imageUrl !== this.#failedImageUrl() ? imageUrl : null;
  });

  onImageError(): void {
    const imageUrl = this.image()?.trim();

    if (imageUrl) {
      this.#failedImageUrl.set(imageUrl);
    }
  }
}
